module.exports = __webpack_public_path__ + "img/edit.e5ed5337.svg";